import { Typography } from '@mui/material';

import { useTranslate } from 'react-admin';
import CustomInput from '../../../components/customInput/CustomInput';
import {
  CategoryTranslationInput,
  TranslationInput,
} from '../../../config/types/custom/TranslationInput';
import { LanguageModel } from '../../../config/types/models';

type IProps = {
  id: string | undefined;
  name: string;
  translations: CategoryTranslationInput[];
  setName: (a: string) => void;
  setTranslations: (a: CategoryTranslationInput[]) => void;
  languages: LanguageModel[];
  slug: string;
  setSlug: (a: string) => void;
};

function CategoryNames({
  id,
  name,
  translations,
  setName,
  setTranslations,
  languages,
  slug,
  setSlug,
}: IProps) {
  const t = useTranslate();
  const onChangeTranslation = (lang: LanguageModel, val: string) => {
    const newTranslations = [
      ...translations.filter(
        (c) => !(c.languageId === lang.id && c.key === 'name')
      ),
      {
        languageId: lang.id,
        key: 'name',
        value: val,
      },
    ];
    setTranslations(newTranslations);
  };
  return (
    <>
      <Typography variant='subtitle1'>{t('categoryName')}</Typography>

      <CustomInput
        name='id'
        defaultValue={id}
        label={t('id')}
        placeholder={'id'}
        onBlur={(e) => setSlug(e.target.value)}
        readOnly
        style={{
          width: '100%',
        }}
      />

      <CustomInput
        name='slug'
        defaultValue={slug}
        label={t('slug')}
        placeholder={'Slug'}
        onBlur={(e) => setSlug(e.target.value)}
        style={{
          width: '100%',
        }}
      />

      <CustomInput
        name='name'
        defaultValue={name}
        label={languages?.find((c) => c.isDefault === true)?.name || null}
        placeholder={languages?.find((c) => c.isDefault === true)?.name}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setName(e.target.value)}
      />
      {languages
        ?.filter((c) => c.isDefault === false)
        .map((lang) => (
          <CustomInput
            label={lang.name}
            style={{
              width: '100%',
            }}
            value={
              translations?.find(
                (c) => c.languageId === lang.id && c.key === 'name'
              )?.value || ''
            }
            onChange={(e) => onChangeTranslation(lang, e.target.value)}
          />
        ))}
    </>
  );
}

export default CategoryNames;
